import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "h-screen flex flex-col" }
const _hoisted_2 = { class: "flex flex-1 min-h-0" }
const _hoisted_3 = { class: "w-64 h-screen flex flex-col bg-gray-100 dark:bg-gray-900 border-r border-gray-300 dark:border-gray-700 transition-colors duration-200" }
const _hoisted_4 = { class: "p-4 border-b border-gray-300 dark:border-gray-700 bg-transparent" }
const _hoisted_5 = { class: "mt-4 flex-1 overflow-y-auto" }
const _hoisted_6 = { class: "flex flex-col" }
const _hoisted_7 = {
  key: 0,
  class: "flex flex-col"
}
const _hoisted_8 = { class: "flex items-center px-4 py-3 text-gray-600 dark:text-gray-300 font-medium" }
const _hoisted_9 = {
  key: 0,
  class: "px-8 pt-3 pb-1 text-[10px] uppercase tracking-wider text-gray-400 dark:text-gray-500 select-none"
}
const _hoisted_10 = ["aria-expanded", "aria-controls", "onClick"]
const _hoisted_11 = { class: "relative shrink-0 mr-3 flex" }
const _hoisted_12 = {
  key: 0,
  class: "absolute -top-0.5 -right-0.5 w-1.5 h-1.5 rounded-full bg-amber-500 ring-1 ring-white dark:ring-gray-900",
  title: "Beta",
  "aria-label": "Beta"
}
const _hoisted_13 = { class: "flex-1 min-w-0 truncate text-left" }
const _hoisted_14 = ["id"]
const _hoisted_15 = { class: "flex-1 min-w-0 truncate" }
const _hoisted_16 = { class: "relative shrink-0 mr-3 flex" }
const _hoisted_17 = {
  key: 0,
  class: "absolute -top-0.5 -right-0.5 w-1.5 h-1.5 rounded-full bg-amber-500 ring-1 ring-white dark:ring-gray-900",
  title: "Beta",
  "aria-label": "Beta"
}
const _hoisted_18 = { class: "flex-1 min-w-0 truncate" }
const _hoisted_19 = { class: "relative shrink-0 mr-3 flex" }
const _hoisted_20 = {
  key: 0,
  class: "absolute -top-0.5 -right-0.5 w-1.5 h-1.5 rounded-full bg-amber-500 ring-1 ring-white dark:ring-gray-900",
  title: "Beta",
  "aria-label": "Beta"
}
const _hoisted_21 = { class: "flex-1 min-w-0 truncate" }
const _hoisted_22 = { class: "flex-shrink-0 p-4 border-t border-gray-300 dark:border-gray-700" }
const _hoisted_23 = {
  key: 0,
  class: "flex items-center mb-3"
}
const _hoisted_24 = { class: "flex flex-col" }
const _hoisted_25 = { class: "text-sm font-medium text-gray-800 dark:text-white" }
const _hoisted_26 = { class: "text-xs text-gray-600 dark:text-gray-400 max-w-[180px] truncate" }
const _hoisted_27 = { class: "flex items-center justify-between mb-3 px-1" }
const _hoisted_28 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-4 w-4 text-yellow-300 absolute right-1",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
}
const _hoisted_29 = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-4 w-4 text-blue-400 absolute left-1",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
}
const _hoisted_30 = { class: "flex-1 overflow-auto bg-white dark:bg-gray-800" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ViewAsBanner = _resolveComponent("ViewAsBanner")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_LogoutIcon = _resolveComponent("LogoutIcon")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_ViewAsBanner),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_router_link, {
            to: "/",
            class: "flex items-center justify-center cursor-pointer p-1 logo-link"
          }, {
            default: _withCtx(() => _cache[2] || (_cache[2] = [
              _createElementVNode("div", { class: "flex items-center" }, [
                _createElementVNode("svg", {
                  xmlns: "http://www.w3.org/2000/svg",
                  class: "h-9 w-9 mr-1",
                  viewBox: "0 0 24 24"
                }, [
                  _createElementVNode("path", {
                    d: "M14.7 6.3a1 1 0 000 1.4l1.6 1.6a1 1 0 001.4 0l3.77-3.77a6 6 0 01-7.94 7.94l-6.91 6.91a2.12 2.12 0 01-3-3l6.91-6.91a6 6 0 017.94-7.94l-3.76 3.76z",
                    fill: "#FFD700",
                    stroke: "#FFD700",
                    "stroke-width": "0.5"
                  })
                ]),
                _createElementVNode("div", { class: "flex items-center" }, [
                  _createElementVNode("span", { class: "text-3xl font-bold text-blue-500" }, "dev"),
                  _createElementVNode("span", { class: "text-3xl font-bold text-green-500" }, "tools")
                ])
              ], -1)
            ])),
            _: 1,
            __: [2]
          })
        ]),
        _createElementVNode("nav", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menuItems, (item) => {
              return (_openBlock(), _createElementBlock(_Fragment, {
                key: item.name
              }, [
                ((item as FolderMenuItem).type === 'folder')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                      _createElementVNode("div", _hoisted_8, [
                        (_openBlock(), _createBlock(_resolveDynamicComponent(item.icon), { class: "w-5 h-5 mr-3" })),
                        _createElementVNode("span", null, _toDisplayString(item.name), 1)
                      ]),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((item as FolderMenuItem).children, (child) => {
                        return (_openBlock(), _createElementBlock(_Fragment, {
                          key: (child as RegularMenuItem).path || child.name
                        }, [
                          ((child as DividerMenuItem).type === 'divider')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(child.name), 1))
                            : ((child as SubFolderMenuItem).type === 'subfolder')
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                  _createElementVNode("button", {
                                    type: "button",
                                    class: _normalizeClass(["w-full flex items-center px-8 py-2 text-gray-700 dark:text-gray-200 hover:bg-gray-200 dark:hover:bg-gray-800 font-medium", {
                          'bg-gray-200 dark:bg-gray-800': _ctx.isActive(
                            (child as SubFolderMenuItem).path
                          )
                        }]),
                                    "aria-expanded": _ctx.isSubfolderExpanded(child as SubFolderMenuItem),
                                    "aria-controls": `subfolder-${(child as SubFolderMenuItem).path}`,
                                    onClick: ($event: any) => (_ctx.toggleSubfolder(child as SubFolderMenuItem))
                                  }, [
                                    _createElementVNode("span", _hoisted_11, [
                                      (_openBlock(), _createBlock(_resolveDynamicComponent((child as SubFolderMenuItem).icon), { class: "w-5 h-5" })),
                                      ((child as SubFolderMenuItem).beta)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_12))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _createElementVNode("span", _hoisted_13, _toDisplayString(child.name), 1),
                                    (_openBlock(), _createElementBlock("svg", {
                                      xmlns: "http://www.w3.org/2000/svg",
                                      class: _normalizeClass(["w-4 h-4 ml-1 shrink-0 transition-transform duration-150", {
                            'rotate-90': _ctx.isSubfolderExpanded(child as SubFolderMenuItem)
                          }]),
                                      fill: "none",
                                      viewBox: "0 0 24 24",
                                      stroke: "currentColor",
                                      "stroke-width": "2",
                                      "aria-hidden": "true"
                                    }, _cache[3] || (_cache[3] = [
                                      _createElementVNode("path", {
                                        "stroke-linecap": "round",
                                        "stroke-linejoin": "round",
                                        d: "M9 5l7 7-7 7"
                                      }, null, -1)
                                    ]), 2))
                                  ], 10, _hoisted_10),
                                  _withDirectives(_createElementVNode("div", {
                                    id: `subfolder-${(child as SubFolderMenuItem).path}`
                                  }, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((child as SubFolderMenuItem).children, (grand) => {
                                      return (_openBlock(), _createBlock(_component_router_link, {
                                        key: grand.path,
                                        to: grand.path,
                                        class: _normalizeClass(["flex items-center pl-14 pr-4 py-1.5 text-sm text-gray-600 dark:text-gray-400 hover:bg-gray-200 dark:hover:bg-gray-800", {
                            'bg-gray-200 dark:bg-gray-800 font-medium text-gray-800 dark:text-gray-100':
                              _ctx.route.path === grand.path
                          }])
                                      }, {
                                        default: _withCtx(() => [
                                          _createElementVNode("span", _hoisted_15, _toDisplayString(grand.name), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["to", "class"]))
                                    }), 128))
                                  ], 8, _hoisted_14), [
                                    [_vShow, _ctx.isSubfolderExpanded(child as SubFolderMenuItem)]
                                  ])
                                ], 64))
                              : (_openBlock(), _createBlock(_component_router_link, {
                                  key: 2,
                                  to: (child as RegularMenuItem).path,
                                  class: _normalizeClass(["flex items-center px-8 py-2 text-gray-600 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-800", {
                        'bg-gray-200 dark:bg-gray-800 font-medium': _ctx.isActive(
                          (child as RegularMenuItem).path
                        )
                      }])
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("span", _hoisted_16, [
                                      (_openBlock(), _createBlock(_resolveDynamicComponent((child as RegularMenuItem).icon), { class: "w-5 h-5" })),
                                      ((child as RegularMenuItem).beta)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_17))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _createElementVNode("span", _hoisted_18, _toDisplayString(child.name), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["to", "class"]))
                        ], 64))
                      }), 128))
                    ]))
                  : (_openBlock(), _createBlock(_component_router_link, {
                      key: 1,
                      to: (item as RegularMenuItem).path,
                      class: _normalizeClass(["flex items-center px-4 py-3 text-gray-600 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-800", {
                  'bg-gray-200 dark:bg-gray-800 font-medium': _ctx.isActive(
                    (item as RegularMenuItem).path
                  )
                }])
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", _hoisted_19, [
                          (_openBlock(), _createBlock(_resolveDynamicComponent(item.icon), { class: "w-5 h-5" })),
                          (item.beta)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_20))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("span", _hoisted_21, _toDisplayString(item.name), 1)
                      ]),
                      _: 2
                    }, 1032, ["to", "class"]))
              ], 64))
            }), 128))
          ])
        ]),
        _createElementVNode("div", _hoisted_22, [
          (_ctx.user)
            ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                _createElementVNode("div", {
                  class: "w-8 h-8 rounded-full flex items-center justify-center mr-2",
                  style: _normalizeStyle({
                backgroundColor: _ctx.getUserColor,
                color: 'white',
                fontWeight: 'bold',
                fontSize: '0.875rem'
              })
                }, _toDisplayString(_ctx.getUserInitials), 5),
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.user.name), 1),
                  _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.user.email), 1)
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_27, [
            _cache[6] || (_cache[6] = _createElementVNode("span", { class: "text-sm text-gray-600 dark:text-gray-400" }, "Theme", -1)),
            _createElementVNode("button", {
              class: "flex items-center justify-center rounded-full w-10 h-5 bg-gray-300 dark:bg-gray-600 relative",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.theme.toggleTheme && _ctx.theme.toggleTheme(...args)))
            }, [
              (_ctx.theme.isDark.value)
                ? (_openBlock(), _createElementBlock("svg", _hoisted_28, _cache[4] || (_cache[4] = [
                    _createElementVNode("path", {
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      "stroke-width": "2",
                      d: "M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z"
                    }, null, -1)
                  ])))
                : (_openBlock(), _createElementBlock("svg", _hoisted_29, _cache[5] || (_cache[5] = [
                    _createElementVNode("path", {
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      "stroke-width": "2",
                      d: "M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z"
                    }, null, -1)
                  ]))),
              _createElementVNode("div", {
                class: _normalizeClass(["w-4 h-4 rounded-full absolute transition-all duration-300 transform bg-gray-200", _ctx.theme.isDark.value ? 'translate-x-2' : '-translate-x-2'])
              }, null, 2)
            ])
          ]),
          _createElementVNode("button", {
            class: "w-full flex items-center justify-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-rose-500 dark:bg-red-600 hover:bg-rose-600 dark:hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-rose-500 dark:focus:ring-red-500 transition-colors duration-200",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleLogout && _ctx.handleLogout(...args)))
          }, [
            _createVNode(_component_LogoutIcon, { class: "w-4 h-4 mr-2" }),
            _cache[7] || (_cache[7] = _createTextVNode(" Logout "))
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_30, [
        _createVNode(_component_router_view)
      ])
    ])
  ]))
}